import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";

const MAX_SIZE = 8 * 1024 * 1024; // 8 MB
const ACCEPT = { "image/jpeg": [], "image/png": [], "image/webp": [] };

export default function ImageDropzone({ files, setFiles, label, testId }) {
  const [error, setError] = useState("");

  const onDrop = useCallback(async (accepted, rejected) => {
    setError("");
    if (rejected?.length) setError("Only JPEG / PNG / WEBP under 8MB are accepted.");
    const next = [];
    for (const f of accepted) {
      const b64 = await fileToBase64(f);
      next.push({ name: f.name, mime: f.type, size: f.size, b64, preview: `data:${f.type};base64,${b64}` });
    }
    setFiles([...(files || []), ...next]);
  }, [files, setFiles]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, accept: ACCEPT, maxSize: MAX_SIZE });

  const remove = (i) => setFiles(files.filter((_, idx) => idx !== i));

  return (
    <div>
      <div className="overline" style={{ marginBottom: 8 }}>{label}</div>
      <div {...getRootProps()} className={`v-dropzone ${isDragActive ? "is-drag" : ""}`} data-testid={testId}>
        <input {...getInputProps()} />
        <div className="overline" style={{ color: "var(--v-text)" }}>Drop images or click</div>
        <p style={{ marginTop: 8, color: "var(--v-text-2)", fontSize: 13 }}>JPEG / PNG / WEBP · multiple allowed · under 8MB each</p>
      </div>
      {error && <div className="mono" style={{ color: "var(--v-accent)", marginTop: 8, fontSize: 12 }}>{error}</div>}
      {files?.length > 0 && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3" style={{ marginTop: 16 }}>
          {files.map((f, i) => (
            <div key={`${f.name}-${f.size}-${i}`} className="v-surface" style={{ padding: 8, position: "relative" }}>
              <img src={f.preview} alt={f.name} style={{ width: "100%", aspectRatio: "1/1", objectFit: "cover" }} />
              <div className="mono" style={{ fontSize: 10, marginTop: 6, color: "var(--v-text-2)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{f.name}</div>
              <button onClick={() => remove(i)} className="mono" data-testid={`${testId}-remove-${i}`} style={{ position: "absolute", top: 6, right: 6, background: "var(--v-text)", color: "var(--v-bg)", border: "none", padding: "2px 6px", fontSize: 10, cursor: "pointer" }}>×</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => {
      const s = r.result || "";
      const comma = s.indexOf(",");
      resolve(comma >= 0 ? s.slice(comma + 1) : s);
    };
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}
